import { FormEvent, useState, useRef } from "react";
import { Search, X } from "lucide-react";
import { Input } from "@/components/ui/input";
import { trackSearchFilteredCleared } from "@/utils/eventTracking";

export const SearchBar = ({
  onSearch,
  disabled = false,
}: {
  onSearch: (query: string) => void;
  disabled?: boolean;
}) => {
  const [query, setQuery] = useState("");
  const prevQueryRef = useRef("");

  const handleSubmit = (e: FormEvent) => {
    e.preventDefault();
    if (query !== prevQueryRef.current) {
      prevQueryRef.current = query;
      onSearch(query);
    }
  };

  const handleClear = () => {
    if (query !== "") {
      setQuery("");
      trackSearchFilteredCleared()
      if (prevQueryRef.current !== "") {
        prevQueryRef.current = "";
        onSearch("");
      }
    }
  };

  return (
    <form onSubmit={handleSubmit} className="w-full">
      <div className="relative w-full">
        {/* Search Icon */}
        <Search className={`absolute pl-1 left-3 top-1/2 transform -translate-y-1/2 ${disabled ? 'text-gray-500' : 'text-gray-400'}`} />

        {/* Input Field */}
        <Input
          type="text"
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          placeholder={window.innerWidth < 768 ? "Search" : "Search your saved posts"}
          className={`pl-10 pr-10 ml-2 py-2 w-full bg-gray-700 border-gray-600 text-white placeholder-gray-400 focus:border-purple-500 focus:ring-purple-500 ${disabled ? 'opacity-50 cursor-not-allowed' : ''}`}
          disabled={disabled}
        />

        {/* Clear Button */}
        {query && !disabled && (
          <div
            className="absolute right-0 p-2 top-1/2 transform -translate-y-1/2 h-full px-3 bg-transparent cursor-pointer"
            onClick={handleClear}
          >
            <X className="h-6 w-4 text-gray-400 hover:text-gray-300" />
          </div>
        )}
      </div>
    </form>
  );
};
